export const getCalibrationFileName = (source) => {
  source = decodeURIComponent(source);
  const result = source && source.match(/(metrologic\#[0-9]+\/)([^\?]+)/) || '';
  return result !== '' ? result[2] : result;
};
